<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- content-header component -->
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    <!-- Basic Alerts start -->
    <section id="sample-page">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">{{ 'BITSO.BITSO' | translate }}</h4>
            </div>
            <div class="card-body pb-1">
              <div id="stepper1" class="bs-stepper horizontal-wizard-example">
                <div class="bs-stepper-header">
                  <div class="step" data-target="#account-details">
                    <button class="step-trigger">
                      <span class="bs-stepper-box">1</span
                      >
                        <span class="bs-stepper-label">
                          <span class="bs-stepper-title">{{ 'BITSO.BITSO_ACCOUNT_DETAILS' | translate }}</span>
                          <!--<span class="bs-stepper-subtitle">Setup Account Details</span> -->
                        </span>
                    </button>
                  </div>
                  <div class="line"><i data-feather="chevron-right" class="font-medium-2"></i></div>
                  <div class="step" data-target="#personal-info">
                    <button class="step-trigger">
                      <span class="bs-stepper-box">2</span
                      ><span class="bs-stepper-label"
                        ><span class="bs-stepper-title">{{ 'BITSO.BITSO_CRYPTO_ASSETS' | translate }}</span
                        ><!--<span class="bs-stepper-subtitle">Add Personal Info</span>--></span
                      >
                    </button>
                  </div>
                  <div class="line"><i data-feather="chevron-right" class="font-medium-2"></i></div>
                  <div class="step" data-target="#cotizacion-info">
                    <button class="step-trigger">
                      <span class="bs-stepper-box">3</span
                      ><span class="bs-stepper-label"
                        ><span class="bs-stepper-title">{{ 'BITSO.BITSO_CRYPTO_QUOTES' | translate }}</span
                        ><!--<span class="bs-stepper-subtitle">Add Personal Info</span>--></span
                      >
                    </button>
                  </div>
                </div>
                <div class="bs-stepper-content">
                  <form (ngSubmit)="(HWForm.form.valid)" #HWForm="ngForm">
                    <div id="account-details" class="content">
                      <form #accountDetailsForm="ngForm">
                        <div class="content-header">
                          <h5 class="mb-0">{{ 'BITSO.BITSO_ACCOUNT_DETAILS' | translate }}</h5>
                        </div>
                        <button type="button" (click)="obtenerInformacionDeCliente()" style="margin: 10px 10px 10px 10px;" class="btn btn-primary" rippleEffect>{{ 'BITSO.GET_CUSTOMER_INFORMATION' | translate }}</button>
                            <!-- ngb-alert component -->
                            <ngb-alert  *ngIf="!alertCloseInformacionDeCliente" [type]="'danger'" [dismissible]="false">
                              <h4 class="alert-heading">{{ 'BITSO.BITSO_ERROR' | translate }}</h4>
                              <div class="alert-body">
                                {{ 'BITSO.BITSO_COMMUNICATION_ERROR' | translate }}
                              </div>
                            </ngb-alert>
                            <!--/ ngb-alert component -->
                        <div class="row"> 
                        <!-- ID y nombre -->
                            <div class="col-md-4">
                              <label>Client ID</label>
                              <input class="form-control" name="client_id" [(ngModel)]="client.client_id" disabled />
                            </div>

                            <div class="col-md-4">
                              <label>Nombre</label>
                              <input class="form-control" name="first_name" [(ngModel)]="client.first_name" disabled />
                            </div>

                            <div class="col-md-4">
                              <label>Apellido Paterno</label>
                              <input class="form-control" name="last_name" [(ngModel)]="client.last_name" disabled />
                            </div>

                            <div class="col-md-4">
                              <label>Apellido Materno</label>
                              <input class="form-control" name="second_last_name" [(ngModel)]="client.second_last_name" disabled />
                            </div>

                            <div class="col-md-4">
                              <label>Email</label>
                              <input class="form-control" name="email_stored" [(ngModel)]="client.email_stored" type="email" disabled />
                            </div>

                            <div class="col-md-4">
                              <label>Teléfono</label>
                              <input class="form-control" name="cellphone_number_stored" [(ngModel)]="client.cellphone_number_stored" disabled />
                            </div>

                            <div class="col-md-4">
                              <label>Género</label>
                              <select class="form-control" name="gender" [(ngModel)]="client.gender" disabled >
                                <option value="M">Masculino</option>
                                <option value="F">Femenino</option>
                                <option value="">Otro</option>
                              </select>
                            </div>

                            <div class="col-md-4">
                              <label>Fecha de nacimiento</label>
                              <input class="form-control" name="date_of_birth" [(ngModel)]="client.date_of_birth" type="date" disabled />
                            </div>

                            <div class="col-md-4">
                              <label>RFC o tipo de contribuyente</label>
                              <input class="form-control" name="tax_payer_type" [(ngModel)]="client.tax_payer_type" disabled />
                            </div>

                            <div class="col-md-4">
                              <label>Residencia</label>
                              <input class="form-control" name="country_of_residence" [(ngModel)]="client.country_of_residence" disabled />
                            </div>

                            <div class="col-md-4">
                              <label>Moneda preferida</label>
                              <input class="form-control" name="preferred_currency" [(ngModel)]="client.preferred_currency" disabled />
                            </div>

                            <div class="col-md-4">
                              <label>Firma de contrato</label>
                              <input class="form-control" name="signed_contract" [(ngModel)]="client.signed_contract" disabled />
                            </div>

                            <div class="col-md-4">
                              <label>Verificación nivel</label>
                              <input class="form-control" name="verification_level" [(ngModel)]="client.verification_level" disabled />
                            </div>

                            <div class="col-md-4">
                              <label>Límite Diario</label>
                              <input 
                                class="form-control" 
                                name="daily_limit" 
                                [value]="client.daily_limit | currency:'MXN':'symbol':'1.2-2'" 
                                disabled />
                            </div>

                            <div class="col-md-4">
                              <label>Límite Mensual</label>
                              <input 
                                class="form-control" 
                                name="monthly_limit" 
                                [value]="client.monthly_limit | currency:'MXN':'symbol':'1.2-2'" 
                                disabled />
                            </div>

                            <div class="col-md-4">
                              <label>Saldo Diario Restante</label>
                              <input 
                                class="form-control" 
                                name="daily_remaining" 
                                [value]="client.daily_remaining | currency:'MXN':'symbol':'1.2-2'" 
                                disabled />
                            </div>

                            <div class="col-md-4">
                              <label>Saldo Mensual Restante</label>
                              <input 
                                class="form-control" 
                                name="monthly_remaining" 
                                [value]="client.monthly_remaining | currency:'MXN':'symbol':'1.2-2'" 
                                disabled />
                            </div>
                        </div>
                      </form>
                    </div>
                    <div id="personal-info" class="content">
                      <form #personalInfoForm="ngForm">
                        <div class="content-header">
                          <h5 class="mb-0">{{ 'BITSO.BITSO_CRYPTO_ASSETS' | translate }}</h5>
                          <!--<small>Entessr Your Personal Info.</small>-->
                        </div>
                        <button type="button"  (click)="obtenerBalanceBitso()" style="margin: 10px 10px 10px 10px;"  class="btn btn-primary" rippleEffect>{{ 'BITSO.GET_BALANCE' | translate }}</button>
                            <!-- ngb-alert component -->
                            <ngb-alert  *ngIf="!alertCloseBalanceBitso" [type]="'danger'" [dismissible]="false">
                              <h4 class="alert-heading">{{ 'BITSO.BITSO_ERROR' | translate }}</h4>
                              <div class="alert-body">
                                {{ 'BITSO.BITSO_COMMUNICATION_ERROR' | translate }}
                              </div>
                            </ngb-alert>
                            <!--/ ngb-alert component -->
                        <div class="table-responsive">
                          <table class="table table-bordered table-striped table-hover">
                            <thead class="thead-dark">
                              <tr>
                                <th>Moneda</th>
                                <th>Disponible</th>
                                <th>Bloqueado</th>
                                <th>Total</th>
                                <th>Depósito Pendiente</th>
                                <th>Retiro Pendiente</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let activo of criptoactivos">
                                <td>{{ activo.currency | uppercase }}</td>
                                <td>{{ activo.available | number:'1.2-8' }}</td>
                                <td>{{ activo.locked | number:'1.2-8' }}</td>
                                <td>{{ activo.total | number:'1.2-8' }}</td>
                                <td>{{ activo.pending_deposit | number:'1.2-8' }}</td>
                                <td>{{ activo.pending_withdrawal | number:'1.2-8' }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </form>
                    </div>
                    <div id="cotizacion-info" class="content">
                      <form [formGroup]="cotizacionForm" (ngSubmit)="obtenerCotizacion()">
                        <div class="content-header">
                          <h5 class="mb-0">{{ 'BITSO.BITSO_CRYPTO_QUOTES' | translate }}</h5>
                          <!--<small>Entessr Your Personal Info.</small>-->
                        </div>
                        <div class="row">
                          <!-- Formulario de cotización -->
                          <div class="col-md-6">
                            <h3>{{ 'BITSO.GET_QUOTE' | translate }}</h3>

                            <div class="form-group">
                              <label for="from_currency">Moneda Origen</label>
                              <input id="from_currency" formControlName="from_currency" class="form-control" />
                              <div *ngIf="f.from_currency?.invalid && f.from_currency?.touched" class="text-danger">
                                Moneda origen es requerida.
                              </div>
                            </div>

                            <div class="form-group">
                              <label for="to_currency">Moneda Destino</label>
                              <input id="to_currency" formControlName="to_currency" class="form-control" />
                              <div *ngIf="f.to_currency?.invalid && f.to_currency?.touched" class="text-danger">
                                Moneda destino es requerida.
                              </div>
                            </div>

                            <div class="form-group">
                              <label for="from_amount">Monto</label>
                              <input id="from_amount" formControlName="from_amount" class="form-control" type="number" step="any" />
                              <div *ngIf="f.from_amount?.invalid && f.from_amount?.touched" class="text-danger">
                                Monto es requerido y debe ser mayor a 0.
                              </div>
                            </div>

                            <button type="submit" class="btn btn-primary" [disabled]="cotizacionForm.invalid">
                              Obtener Cotización
                            </button>
                          </div>

                          <!-- Resultados de la cotización -->
                          <div class="col-md-6">
                            <h3>Resultado de la Cotización</h3>

                            <div *ngIf="cotizacionRespuesta">
                              <p><strong>Id:</strong> {{ cotizacionRespuesta?.id }}</p>
                              <p><strong>Moneda Origen:</strong> {{ cotizacionRespuesta?.from_currency }}</p>
                              <p><strong>Moneda Destino:</strong> {{ cotizacionRespuesta?.to_currency }}</p>
                              <p><strong>Monto de Origen:</strong> {{ cotizacionRespuesta?.from_amount | currency:'USD':true }}</p>
                              <p><strong>Monto de Destino:</strong> {{ cotizacionRespuesta?.to_amount | currency:'USD':true }}</p>


                                <button class="btn btn-success" *ngIf="alertClose" (click)="confirmarCotizacion()" [disabled]="!cotizacionRespuesta?.id">
                                  {{ 'BITSO.CONFIRM_PURCHASE' | translate }}
                                </button>

                                <!-- ngb-alert component -->
                                <ngb-alert  *ngIf="!alertClose" [type]="'success'" [dismissible]="false">
                                  <h4 class="alert-heading">{{ 'BITSO.BITSO_SUCCESS' | translate }}</h4>
                                  <div class="alert-body">
                                    {{ 'BITSO.BITSO_THE_PURCHASE_WAS_COMPLETED_SUCCESSFULLY' | translate }}
                                  </div>
                                </ngb-alert>
                                <!--/ ngb-alert component -->
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Basic Alerts end -->
  </div>
</div>
